import { reject } from 'lodash/fp';
import { PATH_BUILDER } from '../../constants/actionTypes';

export default (state = [], action) => {
  switch (action.type) {
    case PATH_BUILDER.TAGGING.CREATE:
      return state.concat(action.tagging);

    case PATH_BUILDER.TAGGING.REMOVE:
      return reject({ id: action.taggingId }, state);

    default:
      return state;
  }
};
